<template>
    <thead class="header-wrapper">
        <tr>
            <th v-for="col in cols" :key="col.colId" :style="{ width: col.width }">{{ col.header }}</th>
        </tr>
    </thead>
</template>

<script>
export default {
    name: "Header",
    props: ["cols"]
};
</script>

<style lang="less" scoped>
.header-wrapper {
    width: 100%;
    background: #f2f7fb;
    border-top: 1px solid #e3ecf5;
    border-bottom: 1px solid #e3ecf5;
    tr {
        width: 100%;
        border-bottom: 1px solid #e3ecf5;
    }

    th {
        position: relative;
        padding: 14px 10px 15px 20px;
        box-sizing: border-box;
        min-width: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
